import { render } from "./App.vue?vue&type=template&id=e17d6b26"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e17d6b26&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__